<template>
  <div class="user">
    <div class="photo">
      <img src="/static/img/central-gym50x50.webp" alt="AVATAR" />
    </div>
    <div class="info">
      <a
        data-toggle="collapse"
        :aria-expanded="!isClosed"
        @click="toggleMenu"
        class="text-light pointer"
      >
        <span>
          {{ this.username }}
          <b class="caret"></b>
        </span>
      </a>
      <div class="clearfix"></div>
      <div>
        <collapse-transition>
          <ul class="nav nav-menu" v-show="!isClosed">
            <li>
              <a @click="editProfile">
                <span class="sidebar-mini-icon">Mp</span>
                <span class="sidebar-normal">Mi perfil</span>
              </a>
            </li>
            <!-- <li>
              <a>
                <span class="sidebar-mini-icon">Ep</span>
                <span class="sidebar-normal">Editar perfil</span>
              </a>
            </li> -->
            <li>
              <a @click="lock()">
                <span class="sidebar-mini-icon">B</span>
                <span class="sidebar-normal">Bloquear</span>
              </a>
            </li>
            <li>
              <a @click="logout">
                <span class="sidebar-mini-icon">CS</span>
                <span class="sidebar-normal">Cerrar Sesion</span>
              </a>
            </li>
          </ul>
        </collapse-transition>
      </div>
    </div>
  </div>
</template>
<script>
import { CollapseTransition } from "vue2-transitions";

export default {
  components: {
    CollapseTransition,
  },
  data() {
    return {
      isClosed: true,
      username: sessionStorage.getItem("WHbUjdv3TG"),
    };
  },
  methods: {
    toggleMenu() {
      this.isClosed = !this.isClosed;
    },
    logout() {
      this.$router.push("/logout");
    },
    editProfile(){
      this.$router.push('/admin/User')
    },
    lock(){
      this.$router.push('/Lock')
    }
  },
};
</script>
<style scoped>
.nav.nav-menu {
  margin-top: 0;
}
.pointer {
  cursor: pointer;
}
</style>
